import { clone } from 'rambda';
import type { ConversationGroupMessageType, ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import { getUserId } from '@/stores/auth';

export function isGroupMessage(
  message: Nullable<ConversationMessageTypeUnion>,
): message is ConversationGroupMessageType {
  if (!message) return false;
  return 'GroupID' in message && message.GroupID > 0;
}

export function isMessageFromGroupAdmin(conversation: ConversationMessageTypeUnion): boolean {
  if (!isGroupMessage(conversation)) return false;

  const role = conversation.UserRole ?? 0;

  return role >= 9;
}

export function transformMessage(message: ConversationMessageTypeUnion): ConversationMessageTypeUnion {
  const userId = getUserId();
  const newMessage = clone(message);

  if (userId && 'GroupID' in newMessage) {
    const atIds = newMessage.AtIDs?.split('|') ?? [];
    newMessage.GotAt = Boolean(atIds.includes('0') || atIds.includes(userId.toString()));
  }

  return newMessage;
}
